export const contractTypes = [
  {
    id: 1,
    title: "Contratti energia",
    description: "Luce e gas",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Telefonia e internet",
    description: "Mobile e fibra",
    icon: "Wifi"
  },
  {
    id: 3,
    title: "Finanziamenti",
    description: "Prestiti e mutui",
    icon: "CreditCard"
  },
  {
    id: 4,
    title: "Abbonamenti",
    description: "Servizi ricorrenti",
    icon: "RefreshCw"
  },
  {
    id: 5,
    title: "Contratti generici",
    description: "Altri documenti",
    icon: "FileText"
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Carica il contratto",
    description: "PDF o foto del documento",
    icon: "Upload"
  },
  {
    step: 2,
    title: "L'AI analizza",
    description: "Identifica clausole critiche",
    icon: "Brain"
  },
  {
    step: 3,
    title: "Ricevi il report",
    description: "Spiegazione chiara di rischi e punti chiave",
    icon: "FileCheck"
  }
];

export const pricingPlans = [
  {
    id: "basic",
    name: "Report Basic",
    price: "2",
    originalPrice: "5",
    currency: "€",
    popular: false,
    promo: true,
    features: [
      "Sommario del contratto",
      "Identificazione clausole critiche",
      "Valutazione rischi",
      "Azioni consigliate"
    ]
  },
  {
    id: "premium",
    name: "Report Premium",
    price: "5",
    originalPrice: "19",
    currency: "€",
    popular: true,
    promo: true,
    features: [
      "Tutto quanto incluso nel Basic",
      "Analisi dettagliata delle clausole",
      "Conseguenze reali",
      "Consigli strategici prima della firma"
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "Quanto tempo richiede l'analisi?",
    answer: "L'analisi viene completata in pochi minuti. Riceverai il report via email appena pronto."
  },
  {
    id: 2,
    question: "Quali formati di file sono accettati?",
    answer: "Accettiamo file PDF, immagini JPG e PNG. Il documento deve essere leggibile e di buona qualità."
  },
  {
    id: 3,
    question: "Il mio documento è privato?",
    answer: "Assolutamente sì. Il tuo documento viene processato in modo sicuro e utilizzato solo per l'analisi. Non condividiamo i tuoi dati con terze parti."
  }
];

export const trustPoints = [
  {
    icon: "Shield",
    title: "Sicuro e privato",
    description: "I tuoi documenti sono protetti e utilizzati solo per l'analisi"
  },
  {
    icon: "Zap",
    title: "Veloce e comprensibile",
    description: "Spiegazioni rapide e chiare di contratti complessi"
  },
  {
    icon: "AlertCircle",
    title: "Servizio informativo",
    description: "Analisi informativa che non sostituisce la consulenza legale"
  }
];
